var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6545 15.6485C1.05157 14.2191 0.718262 12.648 0.718262 10.9991C0.718262 7.3022 2.39375 3.99663 5.02684 1.80029L10.8494 10.5386L1.6545 15.6485Z",
    fill: "#10AF0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58789 16.4182C5.43608 19.5163 8.82097 21.5914 12.6905 21.5914C18.5401 21.5914 23.2821 16.8494 23.2821 10.9998C23.2821 5.15025 18.5401 0.408203 12.6905 0.408203C10.6374 0.408203 8.7208 0.992335 7.09775 2.00349L13.1585 11.0995L3.58789 16.4182Z",
    fill: "#FDDC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivat);
export default __webpack_public_path__ + "static/media/privat.563af89ca2e577e9c3d48346f2e988b6.svg";
export { ForwardRef as ReactComponent };